<template>
   <vue-final-modal
      v-model="doNotClose" 
      classes="modal-container"
      content-class="not-close-modal-content"
      :click-to-close="false"
      :z-index="3000"
      @opened="$emit('onOpened')"
      >
      <div class="not-close p-0 mt-1">
         <div class="container">
            <!--
            <pre>{{ v310Object }}</pre>
            -->
            <div v-for="(message, index) in messages" :key="index" 
                  class="p-0 py-2 ms-2"
                  >
               <div class="text-center"><b>{{message}}</b></div>
                  
            </div>
            <div class="text-center my-3">
               <div class="spinner-grow text-danger mx-1" role="status">
                  <span class="visually-hidden">Loading...</span>
               </div>
               <div class="spinner-grow text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
               </div>
               <div class="spinner-grow text-primary mx-1" role="status">
                  <span class="visually-hidden">Loading...</span>
               </div>
            </div>
         </div>
      </div>
   </vue-final-modal>
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref } from 'vue';

export default {

   components: {
      VueFinalModal
   },

   props: {
      messages: Array
   },
   
   emits: [ 'onOpened' ],

   //setup(props, { emit }) {

   setup() {

      const doNotClose = ref(true)
      
      return {
         doNotClose
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.not-close-modal-content) {
  /*
  width: 350px;
  background-color: #9E9E9E ;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 25%;
  min-width: 350px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #f67e7e ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.not-close {
   /*
   background-color: #9E9E9E ;
   color: white;
   background-color: #f67e7e ;
   */
   max-height: calc(100vh - 28px);
   overflow-y: auto;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.tj-foot-cell {
   cursor: pointer;
}
.tj-foot-cell:hover {
   background-color: darkgrey;
}
</style>
